var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupMixerTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a14d72c1-e249-4252-adfd-de9a4fe47f61",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".af187ee7-f880-4874-b389-a1673600c976,.ffc173ea-cb8e-4fa2-8e60-f5637863bb55{fill:none;}.af187ee7-f880-4874-b389-a1673600c976{clip-rule:evenodd;}.e0ea8afe-8aa6-4a78-a245-9dd2d472189e{clip-path:url(#a822c29e-0ead-4765-a734-cb6df122a6a8);}.f08bed8a-a416-4b50-8f07-6c92b052cf93{fill:#b2c3c9;}.efcea9b5-7d82-49a1-8693-44ddfded5b15{clip-path:url(#b190a229-6ab9-49db-b48e-a41f6c245311);}.e6e19b7b-f52c-473d-afbc-ed71ec972834{clip-path:url(#afc351fa-9abf-45b4-90cc-6c1f93c3c541);}.f3f76b06-3e6d-4afb-8812-7756b9b4759b{clip-path:url(#f995d1d3-5b08-4b11-9d73-76f2dab5d123);}.b97d6af1-8c70-46ac-8ec6-9c6add5589b1{clip-path:url(#b7caf63e-f5e8-4c09-9867-f11d08d1b8d1);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a822c29e-0ead-4765-a734-cb6df122a6a8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ffc173ea-cb8e-4fa2-8e60-f5637863bb55",
    d: "M6.67,11.75a.28.28,0,0,1-.26.3H1.87a.28.28,0,0,1-.26-.29V11.5a.66.66,0,0,1,0-.28L3.09,8.48a.62.62,0,0,1,.58-.39H6.19c.41,0,.48,0,.48.5Zm15.22,3.59a1,1,0,0,0-.95-.94H8.34a.59.59,0,0,1-.59-.6V7.32a.18.18,0,0,0-.18-.18H3.27a.94.94,0,0,0-.86.57l-2.12,4v0a1,1,0,0,0-.08.38l0,7.55a1,1,0,0,0,1,.95h.14a.18.18,0,0,0,.18-.18,3.18,3.18,0,1,1,6.35,0,.18.18,0,0,0,.18.18H9a.18.18,0,0,0,.18-.18,3.17,3.17,0,0,1,5.87-1.69.17.17,0,0,0,.3,0,3.17,3.17,0,0,1,5.84,1.74.22.22,0,0,1,0,.08,1,1,0,0,0,.71-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b190a229-6ab9-49db-b48e-a41f6c245311"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ffc173ea-cb8e-4fa2-8e60-f5637863bb55",
    d: "M4.69,21.34a.9.9,0,1,1,.89-.9A.89.89,0,0,1,4.69,21.34Zm0-3.44a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,4.69,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "afc351fa-9abf-45b4-90cc-6c1f93c3c541"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ffc173ea-cb8e-4fa2-8e60-f5637863bb55",
    d: "M12.37,21.34a.9.9,0,1,1,.89-.9A.89.89,0,0,1,12.37,21.34Zm0-3.44a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,12.37,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f995d1d3-5b08-4b11-9d73-76f2dab5d123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ffc173ea-cb8e-4fa2-8e60-f5637863bb55",
    d: "M18,21.35a.89.89,0,1,1,.89-.89A.88.88,0,0,1,18,21.35Zm0-3.43a2.54,2.54,0,1,0,2.52,2.54A2.52,2.52,0,0,0,18,17.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7caf63e-f5e8-4c09-9867-f11d08d1b8d1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af187ee7-f880-4874-b389-a1673600c976",
    d: "M23.64,7.69,22.8,5.37a1.65,1.65,0,0,0-1.05-1L17,2.85l-.26-.06A.17.17,0,0,0,16.6,3L18,6.88a.58.58,0,0,1-.24.7A.52.52,0,0,1,17,7.29L15.59,3.35a.26.26,0,0,0-.35-.16L12.36,4.34a.29.29,0,0,0-.16.38l1.46,4a.59.59,0,0,1-.24.71.52.52,0,0,1-.74-.29l-1.45-4A.24.24,0,0,0,10.85,5a1,1,0,0,0-.18.18L9.14,7.08a1.8,1.8,0,0,0-.31,1.66L10,12.34a1.63,1.63,0,0,0,1.54,1.17h8.28a1.6,1.6,0,0,0,1.33-.74l2.33-3.5A1.77,1.77,0,0,0,23.64,7.69Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "e0ea8afe-8aa6-4a78-a245-9dd2d472189e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f08bed8a-a416-4b50-8f07-6c92b052cf93",
    x: -4.8,
    y: 2.14,
    width: 31.72,
    height: 23.42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "efcea9b5-7d82-49a1-8693-44ddfded5b15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f08bed8a-a416-4b50-8f07-6c92b052cf93",
    x: -2.82,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "e6e19b7b-f52c-473d-afbc-ed71ec972834"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f08bed8a-a416-4b50-8f07-6c92b052cf93",
    x: 4.86,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "f3f76b06-3e6d-4afb-8812-7756b9b4759b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f08bed8a-a416-4b50-8f07-6c92b052cf93",
    x: 10.53,
    y: 12.92,
    width: 15.03,
    height: 15.08
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "b97d6af1-8c70-46ac-8ec6-9c6add5589b1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f08bed8a-a416-4b50-8f07-6c92b052cf93",
    x: 3.74,
    y: -2.21,
    width: 25,
    height: 20.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupMixerTruck);
export default __webpack_public_path__ + "static/media/pickup-mixer-truck.f75bc52282cf6b3435d39e205955effc.svg";
export { ForwardRef as ReactComponent };